"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const BlockQuote = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 24, height: 18, y: 3, fill: "#716BF1", className: styles.accentColor, rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M16.916 16.667h1.106v-1.168c1.18-.166 1.978-.897 1.978-2.042 0-1.038-.725-1.687-1.83-1.935l-1.23-.283c-.626-.153-.934-.437-.934-.909 0-.566.48-.955 1.242-.955.848 0 1.327.413 1.499.932h1.192c-.221-.968-.86-1.64-1.917-1.853v-1.12h-1.106v1.061c-1.254.118-2.065.932-2.065 2.018 0 1.121.8 1.664 1.77 1.888l1.204.283c.738.165 1.02.449 1.02.932 0 .637-.516 1.003-1.352 1.003-.774 0-1.364-.318-1.597-1.026h-1.229c.209 1.144 1.057 1.84 2.249 2.006z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M4.667 9.333a.667.667 0 1 0 0 1.334H12a.667.667 0 0 0 0-1.334zm0 3.334a.667.667 0 0 0 0 1.333H12a.667.667 0 0 0 0-1.333z",
        opacity: 0.6
      }
    )
  );
};
export default BlockQuote;
